import { useEffect, useState } from "react";

const useIsTransparent = () => {
  const [isTransparent, setIsTransparent] = useState(true);

  useEffect(() => {
    setIsTransparent(false);
  }, []);

  const onCloseClicked = () => {
    setIsTransparent(true);
  }
  return {
    isTransparent,
    onCloseClicked
  }
}

export default useIsTransparent;